"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SYSTEM_TYPE_IDENTIFIER = exports.IFRAME_TITLE = exports.EXTERNAL_ID_IDENTIFIER = exports.EXTERNAL_ID_DELIMITER = void 0;
const EXTERNAL_ID_DELIMITER = exports.EXTERNAL_ID_DELIMITER = '@';
const EXTERNAL_ID_IDENTIFIER = exports.EXTERNAL_ID_IDENTIFIER = 'epic_osw';
const SYSTEM_TYPE_IDENTIFIER = exports.SYSTEM_TYPE_IDENTIFIER = 'epic';
const IFRAME_TITLE = exports.IFRAME_TITLE = 'Schedule Your Appointment';